/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Interface for the 'ShipmentActivities' data
 */
import { Type } from '@angular/core';

export interface ShipmentActivity {
    id: string; // Primary ID
    type: string;
    data: any;
    user?: {
        id: string | number;
        email: string;
        name: string;
    };
    created_at: string | Date;
}

export interface MilestoneChange extends Type<any> {
    milestone_key: string;
    milestone_label: string;
    expected_timestamp: string | Date;
    expected_tz?: string;
    location?: string;
}

export interface StatusUpdate extends Type<any> {
    new_status: string;
    notes?: string;
    reference?: string;
}
